<template>
  <NavHeader>
    <div class="header-icons">
      <CustomTooltip
        v-if="props.enableNewConversationButton"
        :message="$t('legal_assistant.actions.new_conversation')"
        position="bottom"
        size="small"
      >
        <AppIcon
          name="new-conversation"
          size="body-xl"
          :onclick="!chatStore.loading ? resetConversation : null"
          :clickable="true"
        />
      </CustomTooltip>
      <CustomTooltip
        v-if="showHistory"
        :message="$t('legal_assistant.actions.go_history')"
        position="bottom"
        size="small"
      >
        <AppIcon
          name="history"
          size="body-xl"
          :onclick="!chatStore.loading ? navigateToHistory : null"
          :clickable="true"
        />
      </CustomTooltip>
    </div>
  </NavHeader>
</template>
<script setup lang="ts">
import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import NavHeader from '@/components/common/nav-header/NavHeader.vue';
import CustomTooltip from '@/components/common/tooltip/CustomTooltip.vue';
import RouteNames from '@/configuration/router/names.routes';
import { AssistantType, ChatAssistant } from '@/models/assistant-types';
import navigationService from '@/services/NavigationService';
import { useChatStore } from '@/stores/chat-store';

const chatStore = useChatStore();

const props = withDefaults(
  defineProps<{
    assistant: ChatAssistant;
    resetConversation: () => void | Promise<void>;
    showHistory?: boolean;
    enableNewConversationButton?: boolean;
    currentConversationId?: string;
  }>(),
  {
    showHistory: true,
    enableNewConversationButton: false
  }
);

const navigateToHistory = (): void => {
  switch (props.assistant) {
    case AssistantType.LegalAssistant:
      navigationService.navigateTo({
        name: RouteNames.LegalHistory,
        params: { currentConversationId: props.currentConversationId }
      });
      break;
    default:
      navigationService.navigateTo({
        name: RouteNames.ReviewingHistory,
        params: { currentConversationId: props.currentConversationId }
      });
  }
};
</script>
<style scoped lang="scss">
.header-icons {
  display: flex;
  gap: $space-2;
}
</style>
